export default "__VITE_ASSET__CeRkZ6Tz__"